import { AppState } from '../../init/rootReducer';
import { EntitiesState } from '../../types';

// eslint-disable-next-line import/prefer-default-export
export const getEntitiesState = (state: AppState): EntitiesState => state.entities;
